<template>
  <list-layout :tableTools="toggleTableTools">
    <template slot="header">
      <BaseHeader :content="header"/>
    </template>
    <template slot="table-core">
      <base-table-pagination
        ref="baseTablePagRef"
        :total="pagination.total"
        :currentPage="pagination.currentPage"
        :perPage="pagination.pageSize"
        @changeCurrentPage="changeCurrentPage"
        @changePerPage="changePerPage"
      ></base-table-pagination>
      <div class="flex flex-row w-100">
        <base-table-refresh @applyFilters="applyFiltersHandler" />
        <base-table-searches @toggleSearchesDialog="toggleSearchesDialog" />
        <base-table-search @toggleFilters="toggleFilters" />
      </div>
    </template>
    <template slot="table-tags">
      <base-table-filter-tags  :tags="tags" @removeTag="removeFilterTagHanlder" @removeAllTags="removeAllTagsHandler" @saveTags="saveTagsHandler"/>
    </template>
    <template slot="table-component">
      <kendo-grid-component
        :spanish="spanish"
        :dataResult='kendo.dataResult'
        :kendo="kendo"
        :loading='isGeneralLoading'
        :selectedField="selectedField"
        @datastatechange='dataStateChange'
        @columnreorder='columnReorder'
        @rowclick='openPath'
        @columnssubmit='onColumnsSubmit'
        @sortchange='sortChange'
        @filterchange='filterChange'
        @selectionchange="onSelectionChange"
        @headerselectionchange="onHeaderSelectionChange">
      </kendo-grid-component>
    </template>
    <template slot="layout-extend">
      <base-table-select-actions
        :visibility="hasSelected"
        :selected="rowsSelected"
        :total="rowsTotal"
        :baseDropDownVisible="accionesCertificados !== null && accionesCertificados.length > 0 && hasSelected"
      >
        <template slot="commons">
          <base-button :disabled="!hasSelected" size="xs" mode="tools" @click="unselect">
            <base-icon name="vall" size="sm" class="mr-1" :ariaHidden="true"/>
            {{ $t('app.unselect') }}
          </base-button>
        </template>
        <template slot="more">
          <span v-for="action in accionesCertificados" :key="action.id">
              <base-button-item-list theme="dark"  @click="executeAction(action)">
                <base-icon :name="action.icon" class="mr-2" :ariaHidden="true"/>
                {{ action.name }}
            </base-button-item-list>
          </span>
        </template>
      </base-table-select-actions>
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode='primary' :text="labelBtnExcel" icon='excelxls' @click='exportExcel' :loading='isGeneralLoading || loadingExcel' :disabled="loadingExcel"/>
          <base-button-responsive v-if="hasModuleImportaciones && !isRoleUserOrConsulta" mode='primary' :text="$t('app.import_pfx')" icon='import' @click='toggleImport' :loading='isGeneralLoading || loadingExcel' :disabled="loadingExcel"/>
          <base-button-responsive v-if="hasModuleImportaciones && !isRoleUserOrConsulta" mode='primary' :text="$t('app.import_serial')" icon='import' @click='toggleImportCertsSerial' :loading='isGeneralLoading || loadingExcel' :disabled="loadingExcel"/>
          <base-button-responsive data-v-step="2" v-if="!isNotice" mode="primary" :text="$t('certificates.new_certificate')" icon="plus" @click="goToNewCertificate" :loading="isGeneralLoading"/>
        </template>
      </base-footer>
      <import-cert-dialog
        :vuexNamespace="vuexnamespace"
        :dialogOpen="showModalImport" 
        @toggleDialog="toggleImport" 
        @applyDialog="applyImport"
        header="Importación de Certificados PFX" 
        headerValue="Contraseña de los certificados" 
        switchHeaderValue="Tipo de importación"
        switchHeaderValueActive="Certificados y empresas"
        switchHeaderValueInactive="Solo certificados"
        />
      <import-generic-dialog
        :vuexNamespace="vuexnamespace"
        :dialogOpen="showModalImportCertsSerial"
        @toggleDialog="toggleImportCertsSerial"
        @applyDialog="applyImportCertsSerial"
        @downloadTemplate="downloadTemplateCertsSerial"
        header="Importación de Certificados por número de serie" 
        />
      <BaseElDialog
        title="Borrar Certificado"
        :visible.sync="showModal"
        @open="handleOpenModalDialog('container-delete-cert-changes')"
        @closed="releaseFocusDialog"
        width="40%"
        custom-class="min-width-dialog"
        center
        :show-close="false">
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessage }}</span>
        <template slot="footer" >
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-delete-cert-changes">
            <base-button class="w-full" @click="showModal = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
            <base-button class="w-full" mode="secondary-phantom-blue"  :text="$t('app.accept')" @click="() => {deleteHandler(); showModal = false}"/>
          </div>
        </template>
      </BaseElDialog>
      <filter-panel :panelOpen="filterPanel" @togglePanel="toggleFilters" @applyFilters="applyFiltersHandler" />
      <create-search-dialog 
        :numberSearches="numberSearches"
        :idVista="idVista" 
        :dialogOpen="saveSearchDialog" 
        :tags="tags" 
        @toggleDialog="toggleDialogSearches" 
        @applyDialog="applySearchHandler" />
      <filter-panel-searches 
        ref="filterPanelSearches" 
        :idVista="idVista" 
        :vuexnamespace="vuexnamespace" 
        :panelOpen="searchesPanel" 
        @togglePanel="toggleSearchesDialog" 
        @applyFilters="applyFiltersHandler" 
        @updateNumberSearches="updateNumberSearches"/>
    </template>
  </list-layout>
</template>

<script>
import { bus } from '@/main'
import { getCertPorCaducar } from '@/services/notices/getCertPorCaducar'
import { getCertCaducados } from '@/services/notices/getCertCaducados'
import ListLayout from '@/components/layout/ListLayout.vue'
import FilterPanel from '@/components/filters/CertificatesFilter.vue'
import FilterPanelSearches from '@/components/searches/SearchesPanel.vue'
import CreateSearchDialog from '@/components/searches/CreateSearchDialog.vue'
import ImportCertDialog from '@/components/ImportCertDialog.vue'

import { getCertificatesPag } from '@/services/certificates/getCertificatesPag'
// import moment from 'moment'
import { i18n } from '@/i18n'
import { process } from '@progress/kendo-data-query'
// import { saveExcel } from '@progress/kendo-vue-excel-export'
import { downloadExcel } from '@/services/certificates/downloadExcel'
import { downloadExcelCertsCaduc } from '@/services/notices/downloadExcelCertsCaduc'
import { downloadExcelCertsCaducados } from '@/services/notices/downloadExcelCertsCaducados'
import KendoGridComponent from '../../components/KendoGridComponent.vue'
import BaseElDialog from '@/components/base/BaseElDialog.vue'
import { deleteCertificate } from '@/services/certificates/deleteCertificate'
import { importCertificates } from '@/services/configurations/imports/importCertificates'
import ImportGenericDialog from '@/components/ImportGenericDialog.vue'

import { importCertsSerial } from '@/services/configurations/imports/importCertsSerial'
import { downloadTemplateCertsSerial } from '@/services/configurations/imports/downloadTemplateCertsSerial'


export default {
  name: 'list-view',
  components: {
    ListLayout,
    FilterPanel,
    FilterPanelSearches,
    CreateSearchDialog,
    KendoGridComponent,
    BaseElDialog,
    ImportCertDialog,
    ImportGenericDialog,
  },
  data: function () {
    return {
      idVista: 6,
      // Searches
      numberSearches: 0,
      saveSearchDialog: false,
      searchesPanel: false,
      // Import
      showModalImport: false,
      showModalImportCertsSerial: false,
      // All
      accionesCertificadosBase: [
        {
          id: 1,
          icon: 'switchhorizontal',
          name: 'Reemplazar'
        },
        {
          id: 2,
          icon: 'trash',
          name: 'Borrar'
        },
      ],
      loadingExcel: false,
      spanish: true,
      showModal: false,
      header: {
        title: i18n.t('app.certificates'),
        icon: 'certificates',
        breadcrumb: null,
        url: null
      },
      vuexnamespace: 'certificates',
      selectedField: 'selected',
      onlySelected: false,
      filterPanel: false,
      showAllRows: true,
      loadingDataTable: false,
      data: null,
      tableData: [],
      selected: [],
      processMessage: '¿Estás seguro que deseas borrar los certificados seleccionados?',
      isNotice: false,
      noticeType: ''
    }
  },
  computed: {
    hasModuleImportaciones () {
      return this.$store.getters['auth/hasModuleImportaciones']
    },
    hasAnyImportaciones () {
      return this.$store.getters['auth/hasAnyImportaciones']
    },
    accionesCertificados () {
      if (this.selected !== undefined && this.selected !== null && this.selected.length > 1) {
        const acciones = this.accionesCertificadosBase.filter(x => x.id === 2)
        return acciones
      } else {
        return this.accionesCertificadosBase
      }
    },
    labelBtnExcel: function () {
      if (this.hasSelected) return this.$i18n.t('app.export_excel') + ' (Seleccionados)'
      return this.$i18n.t('app.export_excel')
    },
    kendo: function () {
      return this.$store.getters[this.vuexnamespace + '/getKendo']
    },
    isHeadCoreReady: function () {
      return this.$store.getters.isHeadCoreReady
    },
    toggleTableTools: function () {
      return this.selected.length > 0
    },
    rowsSelected: function () {
      return this.selected.length
    },
    rowsTotal: function () {
      return this.selected.length
    },
    setLabelTowShow: function () {
      return this.showAllRows ? 'Solo Seleccionadas' : 'Ver Todas'
    },
    masterFilters: function () {
      return this.$store.getters[this.vuexnamespace + '/getMasterFilters']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    headerCoreFilters: function () {
      return this.$store.getters['auth/queryHeaders']
    },
    tags: function () {
      return this.$store.getters[this.vuexnamespace + '/getTags']
    },
    pagination: function () {
      return this.$store.getters[this.vuexnamespace + '/getPaginationInfo']
    },
    allCifs: function () {
      this.$store.getters['app/allCifs'].forEach(row => {
        this.links.push({ id: row.IdCIFEmpresa, value: row.CIF })
      })
      return this.$store.getters['app/allCifs']
    },
    areAllSelected () {
      return this.data.length === this.selected.length
    },
    hasSelected () {
      return this.selected.length > 0
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isRoleUserOrConsulta: function () {
      return this.role === 'Usuario' || this.role === 'UsuarioConsulta'
    },
  },
  watch: {
    $route (to, from) {
      this.checkIsNotice(to, from)
      this.routerChangeHandler()
      this.applyFilters()
    },
    headerCoreFilters: {
      deep: true,
      handler: 'headerCoreFiltersHandler'
    },
    data (val, oldVal) {
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: this.kendo.sort,
        group: this.kendo.group
      }
      this.kendo.dataResult = process(val, dataState)
      this.unselect()
    }
  },
  created: function () {
    if (this.isRoleUserOrConsulta) {
      this.kendo.columns = this.kendo.columns.filter(x => x.field !== 'selected')
    } 
    // if (this.isRoleUserOrConsulta) this.kendo.columns.shift()
    if (this.$route.meta && this.$route.meta.notice !== undefined && this.$route.meta.notice !== null) {
      this.isNotice = true
      this.noticeType = this.$route.meta.notice
      if (this.noticeType === 'certificadoscaducar') {
        this.header.title = i18n.t('app.noticesCertsCaduc')
      } else if (this.noticeType === 'certificadoscaducados') {
        this.header.title = i18n.t('app.noticesCertsCaducados')
      } else {
        console.error('NoticeType no encontrado o no registrado')
      }
    } else {
      this.isNotice = false
      this.noticeType = ''
      this.header.title = i18n.t('app.certificates')
    }
    if (this.$route.params.data) {
      this.filterByParamsData()
    }
  },
  mounted: async function () {
    // this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
    // this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
    this.$store.commit(this.vuexnamespace + '/setPageSize', this.kendo.take)
    this.data = await this.applyFilters()
  },
  methods: {
    handleOpenModalDialog (refName) {
      this.handleOpenModalDialogMixin(refName)
    },
    releaseFocusDialog () {
      this.releaseFocusDialogMixin()
    },
    routerChangeHandler: async function () {
      this.filterByParamsData()
    },
    toggleImport () {
      this.showModalImport = !this.showModalImport
    },
    toggleImportCertsSerial () {
      this.showModalImportCertsSerial = !this.showModalImportCertsSerial
    }, 
    applyImport: async function (files, form) {
      this.$store.commit('setIsLoading', true)
      try {
        const certificados = []
        const listPromises = []
        // Ejemplo promesas multiples asincronas con espera final de todas
        files.forEach((file) => {
          listPromises.push(this.getBase64(file.raw)
            .then(res => {
              const b64 = res.split(',')[1]
              certificados.push({
                Base64: b64,
                Nombre: file.name
              })
            }))
        })
        await Promise.all(listPromises)
        const payload = {
          idCliente: form.idCliente,
          Password: form.value,
          VincularEmpresas: form.switch,
          Certificados: certificados,
        }
        const response = await importCertificates(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.toggleImport() 
          this.doFeedback('Procesando importación. Puede consultar el estado en esta vista.', 'info')
          if (!this.hasAnyImportaciones) {
            bus.$emit('resetAndUpdateNav', 1000)
          }
          this.$router.push({ name: 'configurations/imports' })
        } 
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    applyImportCertsSerial: async function (file, form) {
      this.$store.commit('setIsLoading', true)
      try {
        const response = await importCertsSerial(file, { idCliente: form.idCliente })
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.toggleImportCertsSerial() 
          this.doFeedback('Procesando importación. Puede consultar el estado en esta vista.', 'info')
          if (!this.hasAnyImportaciones) {
            bus.$emit('resetAndUpdateNav', 1000)
          }
          this.$router.push({ name: 'configurations/imports' })
        } 
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    downloadTemplateCertsSerial: async function () {
      this.$store.commit('setIsLoading', true)
      try {
        const response = await downloadTemplateCertsSerial()
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.downloadBlob(response, 'plantilla-importacion-certificados-serial.xlsx')
        }
      } catch (error) {
        console.error(error)
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    filterByParamsData: function () {
      const data = this.$route.params.data
      const filters = {}
      if (data) {
        data.filters.forEach(filter => {
          if (filter.type === 'cliente') {
            const cliente = { label: 'Cliente', value: filter.data.label }
            filters.empresa = cliente
          }
        })
        this.$store.commit(this.vuexnamespace + '/setMasterFilters', filters)
      }
    },
    executeAction: async function (action) {
      this.selectedAction = action
      if (this.selectedAction.id === 2) { // Borrar
        this.deleteCertificate()
      } else { // Sustituir
        this.replaceCertificate()
      }
    },
    replaceCertificate () {
      this.$router.push({ 
        name: 'certificates/replace',
        params: { 
          idEmpresa: this.selected[0].IdEmpresa, 
          serial: this.selected[0].HashPFX, 
          tipo: this.selected[0].TipoCertificado, 
          name: this.selected[0].CommonName, 
          noticeType: this.noticeType 
        } 
      })
    },
    updateAllSelectedHeader: function () {
      if (!this.hasSelected) {
        this.kendo.columns[0].headerSelectionValue = false
      } else {
        this.kendo.columns[0].headerSelectionValue = this.areAllSelected
      }
    },
    checkIsNotice: function (to, from) {
      if (to.meta && to.meta.notice !== undefined) {
        this.isNotice = true
        this.noticeType = to.meta.notice
        if (this.noticeType === 'certificadoscaducar') {
          this.header.title = i18n.t('app.noticesCertsCaduc')
        } else if (this.noticeType === 'certificadoscaducados') {
          this.header.title = i18n.t('app.noticesCertsCaducados')
        } else {
          console.error('NoticeType no encontrado o no registrado')
        }
      } else {
        this.isNotice = false
        this.noticeType = ''
        this.header.title = i18n.t('app.certificates')
      }
    },
    openPath: function (event) {
      this.$store.commit('app/setheaderBreadCrumb', event.dataItem.CommonName)
      this.$router.push({ 
        name: 'certificates/detail', 
        params: { 
          idEmpresa: event.dataItem.IdEmpresa, 
          serial: event.dataItem.HashPFX, 
          tipo: event.dataItem.TipoCertificado, 
          name: event.dataItem.CommonName, 
          noticeType: this.noticeType 
        } 
      })
    },
    toggleFilters: function () {
      this.filterPanel = !this.filterPanel
    },
    removeFilterTag: function (tag) {
      this.tags.splice(this.tags.indexOf(tag), 1)
    },
    createAppState: function (dataState) {
      this.kendo.take = dataState.take
      this.kendo.skip = dataState.skip
      if (dataState.group) {
        // eslint-disable-next-line no-return-assign
        // dataState.group.map(group => group.aggregates = this.aggregates)
      }
      this.kendo.group = dataState.group
      this.kendo.filter = dataState.filter
      this.kendo.sort = dataState.sort
    },
    dataStateChange: async function (event) {
      this.createAppState(event.data)
      this.data = await this.applyFilters()
    },
    columnReorder: function (options) {      
      this.sendUpdatedColumns(options.columns)
      this.kendo.columns.forEach((column, index) => {
        if (options.columns.filter(x => x.field === column.field).length === 0) {
          column.orderIndex = index + this.kendo.columns.length
          options.columns.push(column)
        }
      })
      this.kendo.columns = options.columns
    },
    exportExcel: async function () {
      this.$store.commit('app/setLoading', true)
      this.loadingExcel = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = {
        serial: data.serial ? data.serial.value : null,
        commonName: data.name ? data.name.value : null,
        Distribuidor: data.distribuidor ? data.distribuidor.value : null,
        Empresa: data.empresa ? data.empresa.value : null,
        fechaCaducidadDesde: data.expires_from ? data.expires_from.value : null,
        fechaCaducidadHasta: data.expires_to ? data.expires_to.value : null,
        tipoCert: data.tipoCert ? data.tipoCert.value : null,
        enUso: data.enUso ? data.enUso.value : null,
        nombreAgrupacion: data.nombreAgrupacion ? data.nombreAgrupacion.value : null,
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      const objColumnas = this.getColumnsGroupExcelMixin(this.kendo.columns, this.kendo.group)
      const payload = { order: objOrder.order, grupos: objColumnas }
      if (this.hasSelected) {
        const selectedIDs = this.selected.map(({ TipoCertificado, IdEmpresa, HashPFX }) => 
          ({ TipoCertificado, IdEmpresa, Serialnumber: HashPFX })
        )
        payload.listaIDs = selectedIDs
      }
      try {
        let response
        if (!this.isNotice) {
          response = await downloadExcel(payload, params)
        } else {
          if (this.noticeType === 'certificadoscaducar') {
            response = await downloadExcelCertsCaduc(payload, params)
          } else if (this.noticeType === 'certificadoscaducados') {
            response = await downloadExcelCertsCaducados(payload, params)
          } else {
            console.error('NoticeType no encontrado o no registrado')
          }
        }
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = 'certificados.xlsx'
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
        this.loadingExcel = false
      }
    },
    onColumnsSubmit: function (columnsState) {
      this.sendUpdatedColumns(columnsState)
      this.kendo.columns = columnsState
    },
    sortChange: function (e) {
      let sort = e.sort
      if (Array.isArray(e)) {
        sort = e
      }
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: sort,
        group: this.kendo.group,
        filter: this.kendo.filter
      }
      this.dataStateChange({ data: dataState })
    },
    filterChange: function (filter) {
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: this.kendo.sort,
        group: this.kendo.group,
        filter: filter
      }

      this.dataStateChange({ data: dataState })
    },
    expandChange: function (event) {
      event.dataItem[event.target.$props.expandField] = !event.dataItem[event.target.$props.expandField]
    },
    applyFilters: async function (eventData) {
      this.loadingDataTable = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      // console.log('applyFilters', data)
      const params = {
        serial: data.serial ? data.serial.value : null,
        commonName: data.name ? data.name.value : null,
        Distribuidor: data.distribuidor ? data.distribuidor.value : null,
        Empresa: data.empresa ? data.empresa.value : null,
        fechaCaducidadDesde: data.expires_from ? data.expires_from.value : null,
        fechaCaducidadHasta: data.expires_to ? data.expires_to.value : null,
        tipoCert: data.tipoCert ? data.tipoCert.value : null,
        enUso: data.enUso ? data.enUso.value : null,
        nombreAgrupacion: data.nombreAgrupacion ? data.nombreAgrupacion.value : null,
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      try {
        const data = await this.getItemsData(objOrder, params)
        this.data = data
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback(this.$i18n.t('feedback.error.general'))
      }

      // if (this.data !== null) {
      //   this.data.forEach(o => {
      //     o.CertFechaCaducidad = moment(o.CertFechaCaducidad).format('DD-MM-yyyy HH:mm')
      //   })
      // }
      this.updateAllSelectedHeader()
      return this.data
    },
    getItemsData: async function (orders, filters) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const res = await this.getMainData(orders, params)
      if (res.blnError === false) {
        this.data = res.respuesta
        const pagination = {
          total: res.meta?.total,
          currentPage: res.meta?.currentPage,
          totalPages: res.meta?.lastPage,
          pageSize: res.meta?.perPage
        }
        
        this.updatePersistedSortMixin()
        this.$store.commit(this.vuexnamespace + '/setPaginationInfo', pagination)
        this.$store.commit('setIsLoading', false)
      } else {
        this.doFeedback(res.msgError + ' [Código de error: ' + res.codError + ']')
      }
      this.loadingDataTable = false
      return this.data
    },
    async getMainData (orders, filters) {
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      let data
      if (!this.isNotice) {
        data = await getCertificatesPag(orders, params)
      } else {
        if (this.noticeType === 'certificadoscaducar') {
          data = await getCertPorCaducar(orders, params)
        } else if (this.noticeType === 'certificadoscaducados') {
          data = await getCertCaducados(orders, params)
        } else {
          console.error('NoticeType no encontrado o no registrado')
        }
      }
      if (data.blnError === true) {
        this.doFeedback(data.msgError + ' [Código de error: ' + data.codError + ']')
      } else {
        setTimeout(() => {
          this.$nextTick(() => { 
            if (this.$refs.baseTablePagRef) this.$refs.baseTablePagRef.focus() 
          })
          this.doFeedback('Se han refrescado los datos del grid actual', 'info', 3000, true)
        }, 200)
      }
      
      return data
    },
    applyFiltersHandler: async function (eventData) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters(eventData)
    },
    changeCurrentPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', event)
      this.data = await this.applyFilters(null)
    },
    changePerPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setPageSize', event)
      this.kendo.take = event
      this.data = await this.applyFilters(null)
    },
    removeFilterTagHanlder: function (tag) {
      // this.$store.commit(this.vuexnamespace + '/removeTag', tag)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      delete filter[tag[0]]
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
      this.applyFiltersHandler(null)
    },
    headerCoreFiltersHandler: function (obs) {
      if (this.isHeadCoreReady) {
        this.applyFilters(null)
      }
    },
    removeAllTagsHandler: function () {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      this.applyFiltersHandler(null)
    },
    tableSortByChangeHandler: function ({ prop, order }) {
      this.$store.commit(this.vuexnamespace + '/setSort', prop)
      this.$store.commit(this.vuexnamespace + '/setSortOrder', order)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.applyFilters(null)
    },
    unselect: function () {
      const checked = false
      this.mapSelectionKendoGrouping(checked)
      this.updateAllSelectedHeader()
    },
    deleteCertificate: async function () {
      this.showModal = !this.showModal
    },
    onHeaderSelectionChange: function (event) {
      const checked = event.event.target.checked
      this.mapSelectionKendoGrouping(checked)
      this.updateAllSelectedHeader()
    },
    onSelectionChange: function (event) {
      event.dataItem[this.selectedField] = !event.dataItem[this.selectedField]
      this.selected = event.dataItems.filter(d => d.selected === true)
      this.updateAllSelectedHeader()
    },
    deleteHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = []
        for (const element of this.selected) {
          payload.push({
            Serialnumber: element.HashPFX,
            idEmpresa: element.IdEmpresa,
            tipoCertificado: element.TipoCertificado
          })
        }
        const response = await deleteCertificate(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
          this.$store.dispatch('app/getAnnouncementsList')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      this.data = await this.applyFilters()
    },
    goToNewCertificate: function () {
      this.$router.push({ name: 'certificates/detail', params: { idEmpresa: -1, serial: -1, tipo: -1 } })
    },
    toggleSearchesDialog: function () {
      this.searchesPanel = !this.searchesPanel
    },
    saveTagsHandler: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    toggleDialogSearches: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    applySearchHandler: async function () {
      this.toggleDialogSearches()
      // Manda actualizar lista de búsquedas
      this.$refs.filterPanelSearches.updateData()
    },
    updateNumberSearches: async function (number) {
      this.numberSearches = number
    },
  }
}
</script>

<style lang="scss" scoped></style>
